export const DX = {
  navIcd10: "nav-icd10-cm",
  page: "icd10-cm-page",
  title: "icd10-cm-title",
  banner: "icd10-cm-reference-banner",
  search: "icd10-cm-search-input",
  versionFilter: "icd10-cm-version-filter",
  activeFilter: "icd10-cm-active-filter",
  billableFilter: "icd10-cm-billable-filter",
  table: "icd10-cm-table",
  loading: "icd10-cm-loading",
  emptyState: "icd10-cm-empty",
  errorState: "icd10-cm-error",
  row: "icd10-cm-row",
  pagination: "icd10-cm-pagination",
  prevPage: "icd10-cm-prev-page",
  nextPage: "icd10-cm-next-page",
  cappedNotice: "icd10-cm-capped-notice",
  detailDialog: "icd10-cm-detail-dialog",
};
